<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn absolute dark fab right bottom color="error" v-on="on" @click="selectOpponent">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </template>

        <v-stepper v-model="e1">
            <v-stepper-items>
                <v-stepper-content step="1" class="pa-0">
                    <v-card flat>
                        <v-card-title color="blue-grey" class="mb-3 title">상대선수</v-card-title>
                        <v-card-text>
                            <v-autocomplete
                                v-model="opponentId"
                                :items="opponents"
                                outlined
                                chips
                                color="blue-grey lighten-2"
                                label="Select"
                                item-text="name"
                                item-value="id"
                                item-color="blue-grey"
                                >
                                <template v-slot:selection="data">
                                    <v-chip
                                    v-bind="data.attrs"
                                    :input-value="data.selected"                        
                                    @click="data.select"                        >
                                    <v-avatar left>
                                        <v-img :src="data.item.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.name }}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                        </template>
                                        <template v-else>
                                        <v-list-item-avatar>
                                            <img :src="data.item.avatar">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                            <v-list-item-subtitle v-html="data.item.alias"></v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <span class="caption" v-html="data.item.total"></span>
                                            <span class="caption grey--text" v-html="data.item.level"></span>
                                        </v-list-item-action>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text color="blue-grey" @click="checkOpponent(opponentId)">
                                <span class="mr-2">다음 단계</span>
                                <v-icon>mdi-arrow-right</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>

                <v-stepper-content step="2" v-if="user && opponent" class="pa-0">
                    <v-card flat>
                        <v-card-title color="blue-grey" class="mb-3 title">시작점수</v-card-title>
                        <v-card-text>
                            <v-card outlined>
                                <v-row align="center">
                                    <v-col cols="5" class="text-right">
                                        <v-row>
                                            <v-col cols="6">
                                                <v-row>
                                                    <v-col cols="12" class="pa-0">
                                                        {{ user.name }}
                                                    </v-col>
                                                    <v-col cols="12" class="pa-0">
                                                        {{ user.level }} ({{ user.total }})
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                             <v-col cols="6">
                                                <v-avatar>
                                                    <v-img :src="user.avatar"></v-img>
                                                </v-avatar>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="2" class="orange--text title">
                                        <v-row class="justify-center">
                                            {{userStartScore}} - {{opponentStartScore}}
                                        </v-row>                                            
                                    </v-col>
                                    <v-col cols="5" class="text-left">
                                        <v-row>
                                            <v-col cols="6">
                                                <v-avatar>
                                                    <v-img :src="opponent.avatar"></v-img>
                                                </v-avatar>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-row>
                                                    <v-col cols="12" class="pa-0">
                                                        {{ opponent.name }}
                                                    </v-col>
                                                    <v-col cols="12" class="pa-0">
                                                        ({{ opponent.total }}) {{ opponent.level }}
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn text color="blue-grey" @click="e1 = 1">
                                <v-icon>mdi-arrow-left</v-icon>
                                <span class="ml-2">이전 단계</span>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn text color="blue-grey" class="mb-3" @click="createNewGame()">
                                <span class="mr-2">시작</span>
                                <v-icon>mdi-play-circle-outline</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-dialog>    
</template>
<script>
import db from '@/fb'
import slugify from 'slugify'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
    data: () => ({
        dialog: false,
        user: null,
        opponents: [],
        groupId: null,
        aliases: [],
        slugs: [],
        search: null,
        opponentId: '',
        opponent: '',
        games: [],
        e1: 0,
        userStartScore: null,
        opponentStartScore: null
    }),
    methods: {
        selectOpponent() {
            // get the opponents from db
            this.slugs.forEach(slug => {
                // except the user
                if(slug != this.user.id){
                    db.collection('users').doc(slug).get().then(opponent => {
                        if(opponent.data().inGame == false){
                            this.opponents.push({
                                ...opponent.data(),
                                id: opponent.id
                            });
                        }
                    })
                }
            })
        },
        checkOpponent(id){
            if(id){
                db.collection('users').doc(id).get().then(user => {
                    if(user.data().inGame == false){
                        
                        // find out the opponent among the opponents
                        this.opponents.filter(opponent => {
                            if(opponent.id == id){
                                this.opponent = opponent
                            } else {
                                return false
                            }
                        })
                    } else {
                        return false
                    }
                }).then(() => {

                    // work out points gaps             
                    let levelGap = Math.abs(this.user.level - this.opponent.level)
                    if(levelGap == 0){
                        this.userStartScore = 0;
                        this.opponentStartScore = 0;
                    } else if(levelGap == 1) {
                        if(this.user.level < this.opponent.level){
                            this.userStartScore = 0;
                            this.opponentStartScore = 2;
                        } else {
                            this.userStartScore = 2;
                            this.opponentStartScore = 0;
                        }
                    } else {
                        if(this.user.level < this.opponent.level){
                            this.userStartScore = 0;
                            this.opponentStartScore = levelGap + 1;
                        } else {
                            this.userStartScore = levelGap + 1;
                            this.opponentStartScore = 0;
                        }
                    }
                }).then(() => {
                    // go to the next step
                    this.e1 = 2
                })
            } else {
                return false
            }
        },
        createNewGame(){
            // create a new game between the user and the opponent
            db.collection('games').add({
                playerOne: {
                    name: this.user.name,
                    alias: this.user.alias,
                    level: this.user.level,
                    total: this.user.total,
                    wins: this.user.wins,
                    loses: this.user.loses,
                    points: null,
                    result: null,
                    avatar: this.user.avatar
                },
                playerTwo: {
                    name: this.opponent.name,
                    alias: this.opponent.alias,
                    level: this.opponent.level,
                    total: this.opponent.total,
                    wins: this.opponent.wins,
                    loses: this.opponent.loses,
                    points: null,
                    result: null,
                    avatar: this.opponent.avatar
                },
                timeStamp: Date.now(),
                finished: false,
                winner: {
                    alias: null,
                    name: null
                },
                loser: {
                    alias: null,
                    name: null
                },
                group: this.groupId
            }).then(() => {
                // update the statuses of both the user and the opponent into the users info of db
                db.collection('users').doc(this.user.id).update({
                    inGame: true
                }).then(() => {
                    db.collection('users').doc(this.opponentId).update({
                        inGame: true
                    })
                }).then(() => {
                    this.dialog = false;
                    this.showStartingScores = true;
                })
            })
        }
    },
    created(){
        // get the id of this group
        this.groupId = this.$route.params.group_id;

        // get current user
        let user = firebase.auth().currentUser;

        if(user){
            // find the user record
            db.collection('users').where('user_id', '==', user.uid).get()
                .then(snapshot => {
                    snapshot.forEach(doc => {
                        this.user = {
                            ...doc.data(),
                            id: doc.id
                        }
                    })
                }).then(() => {
                    // find the aliases of the opponents of this group
                    db.collection('groups').doc(this.groupId).get().then(group => {
                        let members = group.data().members
                        members.forEach(member => {
                            this.aliases.push(member.alias);
                        })
                    }).then(() => {
                        // turn alias into slug
                        this.slugs = this.aliases.map(alias => {
                            return slugify(alias, {
                                replacement: '-',
                                remove: /[$*_+~.()'"!\-:@]/g,
                                lower: true
                            })
                        })
                    }).then(() => {
                        // get the games from the group
                        db.collection(this.groupId).get().then(games => {
                            games.docs.forEach(game => {
                                this.games.push(game.data())
                            })
                        })
                    })
                })
        } else {
            return false;
        }        
    },
    computed: {
        availableOpponents(){
            return this.opponents.filter(opponent => {
               return opponent.inGame = false;
            })
        }
    }
}
</script>

<style>

</style>